import { render, staticRenderFns } from "./rma-form.vue?vue&type=template&id=0b52f83a"
import script from "./rma-form.vue?vue&type=script&lang=js"
export * from "./rma-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports